import { render, staticRenderFns } from "./SettingsTimesheet.vue?vue&type=template&id=06b2dd3a&scoped=true"
import script from "./SettingsTimesheet.vue?vue&type=script&lang=js"
export * from "./SettingsTimesheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2dd3a",
  null
  
)

export default component.exports